import { Component, OnInit, Input, Output, ElementRef, EventEmitter, Renderer2 } from '@angular/core';
declare var $:any;
@Component({
  selector: 'app-sparkline',
  templateUrl: './sparkline.component.html',
  styleUrls: ['./sparkline.component.scss']
})
export class SparklineComponent implements OnInit {
random: string = '_' + Math.random().toString(36).substr(2, 9);
 @Input() gtype!: string;
 @Input() data: any;
 @Input() barWidth!: string;
 @Input() height!: string;
 @Input() barSpacing!: string;
 @Input() barColor!: string;

 constructor() {}
 ngOnInit() {}
 ngAfterViewInit() {

        if(this.gtype=='bar')
{
            $('#'+this.random).sparkline( this.data, 
            {   
                type: this.gtype,
                height: this.height,
                barWidth: this.barWidth,
                barSpacing: this.barSpacing,       
                barColor: this.barColor
            });  
}
else
{
$('#'+this.random).sparkline( this.data,  {
        type: this.gtype,
        width: this.barWidth,
        height: this.height,
        lineColor: this.barColor,
        fillColor: 'transparent',
        lineWidth: 2,
        spotColor: 'transparent',
        minSpotColor: 'transparent',
        maxSpotColor: 'transparent'
    });
}

}
}
